"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Choropleth = require("./Choropleth.styled");

var _schemes = require("../schemes");

var _react = _interopRequireWildcard(require("react"));

var _d = require("d3");

var _components = require("@dentsu-ui/components");

var _Theme = require("../Themes/Theme");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["isZoomable", "showZoomButtons", "id", "projectionTranslation", "colors", "domain", "unknownColor", "projectionScale", "projectionRotation", "enableGraticule", "borderWidth", "borderColor", "height", "theme"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function Choropleth(_ref) {
  var _ref$isZoomable = _ref.isZoomable,
      isZoomable = _ref$isZoomable === void 0 ? true : _ref$isZoomable,
      _ref$showZoomButtons = _ref.showZoomButtons,
      showZoomButtons = _ref$showZoomButtons === void 0 ? true : _ref$showZoomButtons,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'choropleth' : _ref$id,
      _ref$projectionTransl = _ref.projectionTranslation,
      projectionTranslation = _ref$projectionTransl === void 0 ? [0.5, 0.6] : _ref$projectionTransl,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? _schemes.blue : _ref$colors,
      _ref$domain = _ref.domain,
      domain = _ref$domain === void 0 ? [0, 1000000] : _ref$domain,
      _ref$unknownColor = _ref.unknownColor,
      unknownColor = _ref$unknownColor === void 0 ? '#E0E0E2' : _ref$unknownColor,
      _ref$projectionScale = _ref.projectionScale,
      projectionScale = _ref$projectionScale === void 0 ? 100 : _ref$projectionScale,
      _ref$projectionRotati = _ref.projectionRotation,
      projectionRotation = _ref$projectionRotati === void 0 ? [-10, 0, 0] : _ref$projectionRotati,
      _ref$enableGraticule = _ref.enableGraticule,
      enableGraticule = _ref$enableGraticule === void 0 ? false : _ref$enableGraticule,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? '#fff' : _ref$borderColor,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '500px' : _ref$height,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _Theme.StyledTheme : _ref$theme,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(projectionScale || 100),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      scale = _useState2[0],
      setScale = _useState2[1];

  var initaliseD3 = function initaliseD3() {
    var map = (0, _d.select)(document.querySelector("#".concat(id, " > div:nth-child(2) > div > svg")));
    map.append('preserveAspectRatio', 'xMidYMid meet');

    if (isZoomable) {
      map.call((0, _d.zoom)().on('zoom', function (event) {
        (0, _d.selectAll)("#".concat(id, " > div:nth-child(2) > div > svg > g > path")).attr('transform', event.transform);
      }));
    }
  };

  var handleScale = function handleScale(_ref2) {
    var event = _ref2.event,
        scale = _ref2.scale;
    setScale(scale);
    event.stopPropagation();
  };

  return (0, _jsxRuntime.jsxs)("div", {
    id: id,
    style: {
      height: height,
      position: 'relative'
    },
    children: [(0, _jsxRuntime.jsx)("div", {
      id: "".concat(id, "-button-container"),
      style: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        zIndex: 2,
        right: '2%',
        bottom: '6%'
      },
      children: showZoomButtons ? (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_components.IconButton, {
          icon: "plus",
          variant: "secondary",
          onClick: function onClick(e) {
            return handleScale({
              event: e,
              scale: scale + 30
            });
          },
          style: {
            margin: '15px 0 15px 0',
            alignSelf: 'center'
          }
        }), (0, _jsxRuntime.jsx)(_components.IconButton, {
          icon: "minus",
          variant: "secondary",
          onClick: function onClick(e) {
            return handleScale({
              event: e,
              scale: scale - 30
            });
          },
          style: {
            alignSelf: 'center'
          }
        })]
      }) : null
    }), (0, _jsxRuntime.jsx)(_Choropleth.StyledChoropleth, _objectSpread(_objectSpread({}, props), {}, {
      domain: domain,
      unknownColor: unknownColor,
      projectionRotation: projectionRotation,
      enableGraticule: enableGraticule,
      borderWidth: borderWidth,
      borderColor: borderColor,
      theme: theme,
      colors: colors,
      projectionScale: scale,
      projectionTranslation: projectionTranslation,
      isInteractive: !props.isTooltipDisabled && true,
      layers: ['graticule', 'features', 'legends', function () {
        var observer = new MutationObserver(function (mutationsList, observer) {
          var _iterator = _createForOfIteratorHelper(mutationsList),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var mutation = _step.value;

              if (mutation.type === 'childList') {
                initaliseD3();
                observer.disconnect();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        observer.observe(document.querySelector("#".concat(id, " > div:nth-child(2)")), {
          attributes: false,
          childList: true,
          subtree: false
        });
        return null;
      }]
    }))]
  });
}

Choropleth.defaultProps = {};
Choropleth.displayName = 'Choropleth';
var _default = Choropleth;
exports["default"] = _default;